<template>
  <d-card class="card-small mb-3 h-100">
    <d-card-body>
      <d-form class="add-new-post">
        <d-input size="lg" class="mb-3" :placeholder="$t('editor.subjectline')" v-model="subject" />
        <div ref="editor" class="add-new-post__editor mb-1 input-text"></div>
      </d-form>
    </d-card-body>
    <d-list-group-item class="px-3 top-border-only">
      <d-button
        id="save_draft"
        size="sm"
        :placement="'top'"
        class="btn-outline-accent"
        @click="saveTemplate()"
        :disabled="isTemplateLoading || templateSaved"
      >
        <i class="material-icons">save</i>
        {{ isTemplateLoading ? 'Saving...' : ( templateSaved ? 'Template Saved' : 'Save as Template' ) }}
      </d-button>
      <!-- <d-popover target="save_draft" :triggers="['hover']">
      <!-- <template slot="title">Title Here</template>-->
      <!-- <p>Templates with the same name will be overwritten</p>
      </d-popover>-->

      <d-button size="sm" class="btn-accent ml-auto float-right" @click="sendEmail()">
        <i class="material-icons">send</i>
        {{ $t('editor.send') }}
      </d-button>

      <!-- Comment out preview button for now
      <d-button size="sm" theme="success" class="btn mr-2 float-right" @click="handleClick()">
        <i class="material-icons">visibility</i> Preview
      </d-button>
      -->

      <!-- <d-button size="sm" theme="danger" class="btn mr-2 ml-auto float-right">
        <i class="material-icons">undo</i>
        Undo Send {{ seconds }}
      </d-button>-->
    </d-list-group-item>
    <!-- Modal Preview Template -->
    <!-- TODO: Hook up Preview button & create mail preview window -->
    <d-modal v-if="showModal" size="lg" @close="handleClose">
      <d-modal-header>
        <d-modal-title>{{ $t('editor.preview') }}</d-modal-title>
      </d-modal-header>
      <d-modal-body class="pt-2">
        <div class="row mt-4"></div>
      </d-modal-body>
      <div class="modal-footer">
        <d-button size="sm" theme="danger" class="btn ml-auto">{{ $t('editor.cancel') }}</d-button>
        <d-button size="sm" class="ml-2 btn-accent">{{ $t('editor.save') }}</d-button>
      </div>
    </d-modal>
    <!-- / Modal Preview Template -->
  </d-card>
</template>

<script>
import Quill from "quill";
import { TEMPLATE_CREATE, TEMPLATE_SET_CURRENT } from "@/store/types";
import { mapGetters } from "vuex";

export default {
  props: {
    handleSend: Function,
    sendModalToggle: Function
  },
  data() {
    return {
      showModal: false,
      seconds: "15",
      quill: null,
      subject: "",
      templateSaved: false
    };
  },
  name: "editor",
  computed: {
    ...mapGetters(["isTemplateLoading"])
  },
  mounted() {
    const toolbarOptions = [
      // [{ header: [1, 2, 3, 4, 5, false] }],
      ["bold", "italic", "underline"]
      // ["blockquote", "code-block"],
      // [{ header: 1 }, { header: 2 }],
      // [{ list: "ordered" }, { list: "bullet" }],
      // [{ script: "sub" }, { script: "super" }],
      // [{ indent: "-1" }, { indent: "+1" }]
    ];

    // Init the Quill RTE
    this.quill = new Quill(this.$refs.editor, {
      modules: {
        toolbar: toolbarOptions
      },
      placeholder: this.$t("editor.editorplaceholder"),
      theme: "snow"
    });

    this.$eventHub.$on("update-content", template => {
      this.quill.clipboard.dangerouslyPasteHTML(template.body);
      this.subject = template.subject;
    });

    this.$eventHub.$on("add-link", url => {
      const selection = this.quill.getSelection(true);
      this.quill.insertText(selection.index, `{{ %link "${url}" }}`);
    });

    this.$eventHub.$on("add-input", input => {
      const selection = this.quill.getSelection(true);
      this.quill.insertText(selection.index, input);
    });
  },
  showPreviewModal: false,
  methods: {
    sendEmail() {
      //replace empty p > br tags as gmail margin space between p tags
      const contentHTML = document
        .getElementsByClassName("ql-editor")[0]
        .innerHTML.replace(/(<p><br><\/p>)/g, "");

      this.handleSend({
        subject: this.subject,
        body: contentHTML
      });
      this.sendModalToggle();
    },
    handleClick() {
      this.showModal = true;
    },
    handleClose() {
      this.showModal = false;
    },
    async saveTemplate() {
      // TODO: Need to add ability to set name and tags
      const { subject } = this;
      //replace empty p > br tags as gmail margin space between p tags
      const contentHTML = document
        .getElementsByClassName("ql-editor")[0]
        .innerHTML.replace("<p><br></p>", "");

      await this.$store.dispatch(TEMPLATE_CREATE, {
        subject,
        body: contentHTML
      });
      this.templateSaved = true;
    }
  }
};
</script>

